// extracted by mini-css-extract-plugin
module.exports = {"splashStyle":"Launch_splashStyle__26PYW"};